import cn from 'classnames';
import type { Link } from 'react-router';
import { TagLink } from '#components/patterns/entity-links/tag-link/TagLink.tsx';
import type { TagName } from '#dn-types/host.ts';
import styles from './TagLinkWithParens.module.css';

type Props = Omit<React.ComponentPropsWithoutRef<typeof Link>, 'to' | 'children'> & {
  tagName: TagName;
  className?: string;
};

/** {@link TagLinkWithParens} is a variant of {@link TagLink} which adds parentheses surrounding the link, useful when we want to signify that a certain resource is caused by the associated tag. */
export function TagLinkWithParens({ tagName, className, ...linkProps }: Props) {
  return (
    <TagLink
      tagName={tagName}
      className={cn('a no-underline', styles.TagLinkWithParens_tagLink, className)}
      {...linkProps}
    >
      <span className={styles.TagLinkWithParens_parens}>(</span>
      <span className={styles.TagLinkWithParens_tagName}>{tagName}</span>
      <span className={styles.TagLinkWithParens_parens}>)</span>
    </TagLink>
  );
}
